import React from 'react'
import { CircularProgress, Typography } from '@material-ui/core'
import ReviewItemCard from './ReviewItemCard'
import { tokens } from './v4Styles'

const categoryMeta = {
  needs_review: { label: 'Review', color: '#FF9800', textColor: '#fff' },
  aspire_tickets: { label: 'Aspire', color: '#f3e5f5', textColor: '#7b1fa2' },
  field_issues: { label: 'Issues', color: '#ffebee', textColor: '#c62828' },
  stale: { label: 'Stale', color: '#fff3e0', textColor: '#e65100' },
  unread_messages: { label: 'Messages', color: '#efebe9', textColor: '#5d4037' }
}

const ReviewItemList = ({ items, counts, loading, error, selectedItem, hiddenCategories, onSelect, onToggleCategory, onRetry }) => {
  const filteredItems = items.filter(item => !hiddenCategories.has(item.category))

  return (
    <div style={{ width: 380, borderRight: '1px solid #e8e8e8', display: 'flex', flexDirection: 'column', background: '#fff' }}>
      {/* Category Pills */}
      <div style={{ padding: '12px 14px 8px', display: 'flex', gap: 6, flexWrap: 'wrap', borderBottom: '1px solid #f0f0f0' }}>
        {Object.entries(categoryMeta).map(([key, meta]) => {
          const hidden = hiddenCategories.has(key)
          const count = counts[key] || 0
          return (
            <div
              key={key}
              onClick={() => onToggleCategory(key)}
              style={{
                padding: '4px 12px',
                borderRadius: 14,
                background: hidden ? '#f5f5f5' : meta.color,
                color: hidden ? '#bbb' : meta.textColor,
                fontSize: 10,
                fontWeight: key === 'needs_review' ? 700 : 400,
                cursor: 'pointer',
                opacity: hidden ? 0.5 : 1
              }}
            >
              {meta.label} ({count})
            </div>
          )
        })}
      </div>

      {/* Item List */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {loading && (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
            <CircularProgress size={24} />
          </div>
        )}
        {error && (
          <div style={{ padding: 20, textAlign: 'center' }}>
            <Typography variant="body2" color="error">{error}</Typography>
            <Typography
              variant="body2"
              style={{ color: tokens.accent.blue, cursor: 'pointer', marginTop: 8 }}
              onClick={onRetry}
            >
              Retry
            </Typography>
          </div>
        )}
        {!loading && !error && filteredItems.length === 0 && (
          <div style={{ padding: 40, textAlign: 'center' }}>
            <Typography variant="body2" style={{ color: tokens.text.muted }}>
              All caught up — no items need attention
            </Typography>
          </div>
        )}
        {!loading && !error && filteredItems.map((item, index) => (
          <ReviewItemCard
            key={`${item.category}-${item.scheduleItemId}-${index}`}
            item={item}
            selected={selectedItem?.scheduleItemId === item.scheduleItemId && selectedItem?.category === item.category}
            onClick={onSelect}
          />
        ))}
      </div>
    </div>
  )
}

export default ReviewItemList
